module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAA1CAYAAABWW1tXAAAAAXNSR0IArs4c6QAAAHNJREFUWEft2bENgDAMRNFkA2f/ITMCSBQUpKE4SPMywFk+/e8mvaqOtuH17YPnnL/sPca45twbG/xV76pu4AJXqgE60SnF0pIDLnCBK9YAnegUg+kZBC5wgSvWAJ3oFIPJraYTnegUa2DRKZb8Mmjb18AJQvzR8bPrdJMAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/page/crop/nine-to-sixteen.png
// module id = 1emh
// module chunks = 3